module.exports = __webpack_public_path__ + "static/media/mmz3.9787651c.png";